import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { GetUserChatsDataTypes } from "../../../../Schema/getUserChats.types";
import { setChats } from "../../subService/subServiceChats";

export type GetUserChatsLoadAction = {
  type: string;
  payload: { id: number | string | null; subServiceId: number };
};

export type GetUserChatsData = {
  data: {
    data: GetUserChatsDataTypes[];
    message_count: number;
    status: string;
    message_limit: number;
  };
};

const GetUserChats = new ReduxFetchState<
  GetUserChatsData | null,
  { id: number | string | null; subServiceId: number },
  any
>("getUserChats");

export function* watchGetUserChats(action: GetUserChatsLoadAction) {
  const { id, subServiceId } = action.payload;
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: GetUserChatsData = yield axios({
      url: `/api/v1/ai/user-sub-service/${id}/get-chats`,
      method: "GET",
      headers: {
        lang,
      },
    });

    yield put(GetUserChats.actions.loadSuccess({ data: data.data }));
    yield put(setChats({ subServiceId, messages: data.data.data }));
  } catch (e: any) {
    console.log(e, "error is here");
    if (e.code === "ERR_NETWORK") {
      yield put(GetUserChats.actions.load({ id, subServiceId }));
    }
    yield put(GetUserChats.actions.loadFailure(e?.response?.data));
  }
}

export function* getUserChatsSagas() {
  yield takeEvery(GetUserChats.actionTypes.load, watchGetUserChats);
}

export function useGetUserChats() {
  const { loading, data, ...getUserChatsState } = useAppSelector((state) => state.getUserChats);
  const dispatch = useAppDispatch();

  const dispatchGetUserChats = useCallback(
    (data: { id: number | string | null; subServiceId: number }, silent?: boolean) => {
      dispatch(GetUserChats.actions.load(data, silent));
    },
    [dispatch],
  );

  const dispatchCleanResErrors = useCallback(() => {
    dispatch(GetUserChats.actions.loadFailure(null));
  }, [dispatch]);

  return {
    ...getUserChatsState,
    dispatchGetUserChats,
    dispatchCleanResErrors,
    getUserChatsLoading: loading,
    getUserChatsData: data,
  };
}

export const {
  actionTypes: getUserChatsActionsTypes,
  actions: getUserChatsActions,
  reducer: getUserChatsReducer,
} = GetUserChats;
